import SEO from "../components/SEO";
import StructuredData, {
    ACT_LOCAL_BUSINESS_SCHEMA,
} from "../components/StructuredData";
import Hero from "../components/sections/Hero";
import SignatureServices from "../components/sections/SignatureServices";
import Philosophy from "../components/sections/Philosophy";
import BrandsWall from "../components/sections/BrandsWall";
import Testimonials from "../components/sections/Testimonials";
import CTABand from "../components/sections/CTABand";
import { HERO_SLUG } from "../data/content";

export default function Home() {
    return (
        <div data-testid="home-page">
            <SEO
                title="Luxury Smart Home Integration | Advanced Connected Technologies"
                bare
                description="Concierge-grade home automation, security, and audio-video for high-end residences. Certified Control4 and Savant integrators. Book a private consultation."
                canonical="https://actluxe.net/"
                lcpSlug={HERO_SLUG}
                lcpSizes="100vw"
            />
            <StructuredData data={ACT_LOCAL_BUSINESS_SCHEMA} />
            <Hero />
            <SignatureServices />
            <Testimonials />
            <Philosophy />
            <BrandsWall />
            <CTABand />
        </div>
    );
}
